import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'Über uns', id: 'about' },
    { label: 'Leistungen', id: 'services' },
    { label: 'Referenzen', id: 'references' },
    { label: 'Kontakt', id: 'contact' }
  ];

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-gray-950/98 shadow-2xl border-b border-yellow-500/20"
      style={{ backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
    >
      <div className="container mx-auto" style={{ paddingLeft: '24px', paddingRight: '24px' }}>
        <div className="flex items-center justify-between h-20">
          {/* Company Name */}
          <div 
            className="cursor-pointer"
            onClick={() => scrollToSection('home')}
          >
            <h1 className="text-white font-bold text-2xl leading-tight tracking-tight">BALAZS</h1>
            <p className="text-yellow-400 text-sm font-semibold mt-0.5">Dach & Abbruch Service</p>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-yellow-400 font-medium transition-colors duration-200 text-sm uppercase tracking-wide"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href={`tel:${companyInfo.phone}`}
            className="hidden lg:flex items-center space-x-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
          >
            <Phone className="w-4 h-4" />
            <span>{companyInfo.phone}</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2 hover:bg-gray-800 rounded-lg transition-colors duration-200"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-gray-900 border-t border-gray-800">
          <nav className="container mx-auto px-4 py-6 flex flex-col space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-300 hover:text-yellow-400 font-medium transition-colors duration-200 text-left py-2 uppercase tracking-wide"
              >
                {item.label}
              </button>
            ))}
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center justify-center space-x-2 bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-300 mt-4"
            >
              <Phone className="w-4 h-4" />
              <span>{companyInfo.phone}</span>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};